import React from "react";
import { Container, Accordion } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import {Card, Row, Col , Modal} from "react-bootstrap";

const knowledgeArticles = [
  {
    id: 1,
    title: "🌱 Introduction to Organic Farming",
    content: `
Organic farming is an agricultural method that aims to produce food using natural substances and processes. It emphasizes:
- Maintaining soil fertility
- Promoting biodiversity
- Avoiding synthetic chemicals

**Core Principles:**
1. Health
2. Ecology
3. Fairness
4. Care
    `,
  },
  {
    id: 2,
    title: "🌿 Types of Organic Fertilizers",
    content: `
### Common Organic Fertilizers:
- **Compost**: Decomposed organic matter.
- **Vermicompost**: Nutrient-rich waste converted by earthworms.
- **Cow Dung**: A traditional nitrogen source.
- **Bone Meal**: Rich in phosphorus.
- **Green Manure**: Cover crops plowed back into the soil.

**Benefits:**
- Enhances soil structure
- Improves moisture retention
- Boosts microbial activity
    `,
  },
  {
    id: 3,
    title: "🐛 Organic Pest Control Techniques",
    content: `
### Natural Methods:
- **Neem Oil Spray**
- **Garlic and Chili Spray**
- **Crop Rotation**
- **Biological Controls** like ladybugs, wasps

**Why Go Organic?**
Conventional pesticides leave harmful residues on crops and affect beneficial insects. Organic pest control is safer for humans and the environment.
    `,
  },
  {
    id: 4,
    title: "🌾 Crop Rotation in Organic Farming",
    content: `
Crop rotation involves growing different types of crops sequentially on the same land to improve soil health and control pests.

**Example Rotation:**
1. Legumes (adds nitrogen)
2. Leafy greens (uses nitrogen)
3. Root crops
4. Fruit crops

**Advantages:**
- Reduces soil erosion
- Minimizes pest buildup
- Balances nutrient demand
    `,
  },
  {
    id: 5,
    title: "💧 Water Management in Organic Farming",
    content: `
Water conservation is crucial in organic farming:

**Key Techniques:**
- **Drip Irrigation**
- **Mulching** to reduce evaporation
- **Rainwater Harvesting**

These methods help maintain soil moisture, reduce erosion, and improve yield sustainably.
    `,
  },
  {
    id: 6,
    title: "🌻 Companion Planting for Natural Pest Control",
    content: `
Certain plant combinations help deter pests and improve growth.

**Examples:**
- Basil + Tomatoes: Repels whiteflies
- Marigolds + Beans: Deters nematodes
- Garlic + Carrots: Protects from root flies

**Benefits:**
- Pest reduction
- Soil health improvement
- Increased biodiversity
    `,
  },
  {
    id: 7,
    title: "📦 Organic Certification in India",
    content: `
To sell produce as organic, farmers must be certified.

**Certifying Agencies:**
- **NPOP**: National Programme for Organic Production
- **PGS-India**: Participatory Guarantee System

**Process:**
1. Application
2. Conversion period (~3 years)
3. Regular inspections
4. Certification and labeling

**Benefits of Certification:**
- Builds trust
- Increases market value
    `,
  },
];

const Knowledge = () => {
  return (
    <Container className="py-5">
      <h2 className="text-center mb-4">🌿 Knowledge Bank</h2>
      <Accordion defaultActiveKey="0" alwaysOpen>
        {knowledgeArticles.map((article, idx) => (
          <Accordion.Item eventKey={idx.toString()} key={article.id}>
            <Accordion.Header>{article.title}</Accordion.Header>
            <Accordion.Body>
              <ReactMarkdown>{article.content}</ReactMarkdown>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
      <footer className="text-center py-4 mt-5" style={{ backgroundColor: '#f8f9fa' }}>
      <Container>
        <Row className="justify-content-center align-items-center mb-3">
          <Col xs="auto" style={{color: "white"}}>
            <i className="bi bi-headset" style={{ fontSize: '2.5rem', color: '#a8cb41' }}></i>
          </Col>
          <Col xs="auto" className="text-start" style={{color: "white"}}>
            <p className="mb-1 fw-medium" style={{color: "white"}}>Got Questions? Call us 24/7!</p>
            <h5 className="fw-bold text-dark m-0">+91 9654870373</h5>
          </Col>
        </Row>

        <div className="mb-3" style={{color: "white"}}>
          <a href="https://www.facebook.com/people/Mati-Haat/61550736893804/" target="_blank" rel="noopener noreferrer" className="mx-2 text-dark fs-4">
            <i className="bi bi-facebook"></i>
          </a>
          <a href="https://www.instagram.com/matihaat/" target="_blank" rel="noopener noreferrer" className="mx-2 text-dark fs-4" style={{color: "white"}}>
            <i className="bi bi-instagram"></i>
          </a>
          <a href="https://www.youtube.com/@FarmingwithMatihaat" target="_blank" rel="noopener noreferrer" className="mx-2 text-dark fs-4" style={{color: "white"}}>
            <i className="bi bi-youtube"></i>
          </a>
        </div>

        <p className="text-muted mb-0 small" style={{color: "white"}}>© {new Date().getFullYear()} Mati Haat. All rights reserved.</p>
      </Container>
    </footer>     
    </Container>
  );
};

export default Knowledge;
